module.exports = __webpack_public_path__ + "img/table-cells-large.d0a7269c.svg";